import React from 'react';

// Simulating the `item` generic
import PropTypes from "prop-types";
export var DefaultItemActionProps = function DefaultItemActionProps() {
  return ___EmotionJSX("div", null);
};
DefaultItemActionProps.propTypes = {
  /**
     * The type of action
     */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button"]), PropTypes.oneOf(["icon"]).isRequired]),
  /**
     * Defines the color of the button
     */
  color: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.func.isRequired]),
  /**
     * The display name of the action (will render as visible text if rendered within a collapsed menu)
     */
  /**
     * The display name of the action (will render as visible text if rendered within a collapsed menu)
     */
  name: PropTypes.oneOfType([PropTypes.node.isRequired, PropTypes.func.isRequired]).isRequired,
  /**
     * Describes the action (will render as tooltip content)
     */
  /**
     * Describes the action (will render as tooltip content)
     */
  description: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.func.isRequired]).isRequired,
  /**
     * A handler function to execute the action
     */
  /**
     * A handler function to execute the action
     */
  onClick: PropTypes.func,
  href: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.func.isRequired]),
  target: PropTypes.string,
  /**
     * A callback function that determines whether the action is available
     */
  /**
     * A callback function that determines whether the action is available
     */
  available: PropTypes.func,
  /**
     * A callback function that determines whether the action is enabled
     */
  /**
     * A callback function that determines whether the action is enabled
     */
  enabled: PropTypes.func,
  isPrimary: PropTypes.bool,
  "data-test-subj": PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.func.isRequired]),
  /**
     * Associates an icon with the button
     */
  icon: PropTypes.oneOfType([PropTypes.oneOf(["accessibility", "addDataApp", "advancedSettingsApp", "agentApp", "aggregate", "analyzeEvent", "annotation", "apmApp", "apmTrace", "appSearchApp", "apps", "arrowDown", "arrowLeft", "arrowRight", "arrowUp", "arrowStart", "arrowEnd", "article", "asterisk", "at", "auditbeatApp", "beaker", "bell", "bellSlash", "beta", "bolt", "boxesHorizontal", "boxesVertical", "branch", "branchUser", "broom", "brush", "bug", "bullseye", "calendar", "canvasApp", "casesApp", "check", "checkInCircleFilled", "cheer", "classificationJob", "clock", "cloudDrizzle", "cloudStormy", "cloudSunny", "cluster", "codeApp", "color", "compute", "console", "consoleApp", "container", "continuityAbove", "continuityAboveBelow", "continuityBelow", "continuityWithin", "controlsHorizontal", "controlsVertical", "copy", "copyClipboard", "createAdvancedJob", "createMultiMetricJob", "createPopulationJob", "createSingleMetricJob", "cross", "crossClusterReplicationApp", "crosshairs", "currency", "cut", "dashboardApp", "dataVisualizer", "database", "desktop", "devToolsApp", "diff", "discoverApp", "discuss", "document", "documentEdit", "documentation", "documents", "dot", "dotInCircle", "doubleArrowLeft", "doubleArrowRight", "download", "editorAlignCenter", "editorAlignLeft", "editorAlignRight", "editorBold", "editorChecklist", "editorCodeBlock", "editorComment", "editorDistributeHorizontal", "editorDistributeVertical", "editorHeading", "editorItalic", "editorItemAlignBottom", "editorItemAlignCenter", "editorItemAlignLeft", "editorItemAlignMiddle", "editorItemAlignRight", "editorItemAlignTop", "editorLink", "editorOrderedList", "editorPositionBottomLeft", "editorPositionBottomRight", "editorPositionTopLeft", "editorPositionTopRight", "editorRedo", "editorStrike", "editorTable", "editorUnderline", "editorUndo", "editorUnorderedList", "email", "empty", "emsApp", "endpoint", "eql", "eraser", "error", "esqlVis", "exit", "expand", "expandMini", "exportAction", "eye", "eyeClosed", "faceHappy", "faceNeutral", "faceSad", "filebeatApp", "filter", "filterExclude", "filterIgnore", "filterInclude", "filterInCircle", "flag", "fleetApp", "fold", "folderCheck", "folderClosed", "folderExclamation", "folderOpen", "frameNext", "framePrevious", "fullScreen", "fullScreenExit", "function", "gear", "gisApp", "glasses", "globe", "grab", "grabHorizontal", "grabOmnidirectional", "gradient", "graphApp", "grid", "grokApp", "heart", "heartbeatApp", "heatmap", "help", "home", "iInCircle", "image", "importAction", "index", "indexClose", "indexEdit", "indexFlush", "indexManagementApp", "indexMapping", "indexOpen", "indexPatternApp", "indexRollupApp", "indexRuntime", "indexSettings", "indexTemporary", "infinity", "inputOutput", "inspect", "invert", "ip", "key", "keyboard", "kqlField", "kqlFunction", "kqlOperand", "kqlSelector", "kqlValue", "kubernetesNode", "kubernetesPod", "launch", "layers", "lensApp", "lettering", "lineDashed", "lineDotted", "lineSolid", "link", "list", "listAdd", "lock", "lockOpen", "logoAWS", "logoAWSMono", "logoAerospike", "logoApache", "logoAppSearch", "logoAzure", "logoAzureMono", "logoBeats", "logoBusinessAnalytics", "logoCeph", "logoCloud", "logoCloudEnterprise", "logoCode", "logoCodesandbox", "logoCouchbase", "logoDocker", "logoDropwizard", "logoElastic", "logoElasticStack", "logoElasticsearch", "logoEnterpriseSearch", "logoEtcd", "logoGCP", "logoGCPMono", "logoGithub", "logoGmail", "logoGolang", "logoGoogleG", "logoHAproxy", "logoIBM", "logoIBMMono", "logoKafka", "logoKibana", "logoKubernetes", "logoLogging", "logoLogstash", "logoMaps", "logoMemcached", "logoMetrics", "logoMongodb", "logoMySQL", "logoNginx", "logoObservability", "logoOsquery", "logoPhp", "logoPostgres", "logoPrometheus", "logoRabbitmq", "logoRedis", "logoSecurity", "logoSiteSearch", "logoSketch", "logoSlack", "logoUptime", "logoVulnerabilityManagement", "logoWebhook", "logoWindows", "logoWorkplaceSearch", "logsApp", "logstashFilter", "logstashIf", "logstashInput", "logstashOutput", "logstashQueue", "machineLearningApp", "magnet", "magnifyWithExclamation", "magnifyWithMinus", "magnifyWithPlus", "managementApp", "mapMarker", "memory", "menu", "menuDown", "menuLeft", "menuRight", "menuUp", "merge", "metricbeatApp", "metricsApp", "minimize", "minus", "minusInCircle", "minusInCircleFilled", "mobile", "monitoringApp", "moon", "namespace", "nested", "newChat", "node", "notebookApp", "number", "offline", "online", "outlierDetectionJob", "package", "packetbeatApp", "pageSelect", "pagesSelect", "palette", "paperClip", "partial", "pause", "payment", "pencil", "percent", "pin", "pinFilled", "pipeBreaks", "pipelineApp", "pipeNoBreaks", "pivot", "play", "playFilled", "plus", "plusInCircle", "plusInCircleFilled", "popout", "push", "questionInCircle", "quote", "recentlyViewedApp", "refresh", "regressionJob", "reporter", "reportingApp", "returnKey", "save", "savedObjectsApp", "scale", "search", "searchProfilerApp", "securityAnalyticsApp", "securityApp", "securitySignal", "securitySignalDetected", "securitySignalResolved", "sessionViewer", "shard", "share", "snowflake", "sortAscending", "sortDescending", "sortDown", "sortLeft", "sortRight", "sortUp", "sortable", "spaces", "spacesApp", "sparkles", "sqlApp", "starEmpty", "starEmptySpace", "starFilled", "starFilledSpace", "starMinusEmpty", "starMinusFilled", "starPlusEmpty", "starPlusFilled", "stats", "stop", "stopFilled", "stopSlash", "storage", "string", "submodule", "sun", "swatchInput", "symlink", "tableDensityCompact", "tableDensityExpanded", "tableDensityNormal", "tableOfContents", "tag", "tear", "temperature", "timeline", "timelineWithArrow", "timelionApp", "timeRefresh", "timeslider", "training", "transitionLeftIn", "transitionLeftOut", "transitionTopIn", "transitionTopOut", "trash", "unfold", "unlink", "upgradeAssistantApp", "uptimeApp", "user", "userAvatar", "users", "usersRolesApp", "vector", "videoPlayer", "visArea", "visAreaStacked", "visBarHorizontal", "visBarHorizontalStacked", "visBarVertical", "visBarVerticalStacked", "visGauge", "visGoal", "visLine", "visMapCoordinate", "visMapRegion", "visMetric", "visPie", "visTable", "visTagCloud", "visText", "visTimelion", "visVega", "visVisualBuilder", "visualizeApp", "vulnerabilityManagementApp", "warning", "alert", "watchesApp", "wordWrap", "wordWrapDisabled", "workplaceSearchApp", "wrench", "tokenAlias", "tokenAnnotation", "tokenArray", "tokenBinary", "tokenBoolean", "tokenClass", "tokenCompletionSuggester", "tokenConstant", "tokenDate", "tokenElement", "tokenEnum", "tokenEnumMember", "tokenEvent", "tokenException", "tokenField", "tokenFile", "tokenFlattened", "tokenFunction", "tokenGeo", "tokenHistogram", "tokenInterface", "tokenIP", "tokenJoin", "tokenKey", "tokenKeyword", "tokenMethod", "tokenMetricCounter", "tokenMetricGauge", "tokenModule", "tokenNamespace", "tokenNested", "tokenNull", "tokenNumber", "tokenObject", "tokenOperator", "tokenPackage", "tokenParameter", "tokenPercolator", "tokenProperty", "tokenRange", "tokenRankFeature", "tokenRankFeatures", "tokenRepo", "tokenSearchType", "tokenShape", "tokenString", "tokenStruct", "tokenSymbol", "tokenTag", "tokenText", "tokenTokenCount", "tokenVariable", "tokenVectorDense", "tokenDenseVector", "tokenVectorSparse"]).isRequired, PropTypes.func.isRequired])
};
export var SearchProps = function SearchProps() {
  return ___EmotionJSX("div", null);
};
SearchProps.propTypes = [PropTypes.bool.isRequired, PropTypes.shape({
  onChange: PropTypes.func,
  /**
     The initial query the bar will hold when first mounted
     */
  defaultQuery: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.string.isRequired]),
  /**
     If you wish to use the search bar as a controlled component, continuously pass the query via this prop.
     */
  query: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.string.isRequired]),
  /**
     Configures the search box. Set `placeholder` to change the placeholder text in the box and `incremental` to support incremental (as you type) search.
     */
  box: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    isInvalid: PropTypes.bool,
    /**
       * Expand to fill 100% of the parent.
       * Defaults to `fullWidth` prop of `<EuiForm>`.
       * @default false
       */
    fullWidth: PropTypes.bool,
    isLoading: PropTypes.bool,
    /**
       * Called when the user presses [Enter] OR on change if the incremental prop is `true`.
       * If you don't need the on[Enter] functionality, prefer using onChange
       */
    onSearch: PropTypes.func,
    /**
       * When `true` the search will be executed (that is, the `onSearch` will be called) as the
       * user types.
       */
    incremental: PropTypes.bool,
    /**
       * when `true` creates a shorter height input
       */
    compressed: PropTypes.bool,
    inputRef: PropTypes.func,
    /**
       * Shows a button that quickly clears any input
       */
    isClearable: PropTypes.bool,
    /**
       * Creates an input group with element(s) coming before input
       * `string` | `ReactElement` or an array of these
       */
    prepend: PropTypes.oneOfType([PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired).isRequired]),
    /**
       * Creates an input group with element(s) coming after input.
       * `string` | `ReactElement` or an array of these
       */
    append: PropTypes.oneOfType([PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired).isRequired]),
    className: PropTypes.string,
    "aria-label": PropTypes.string,
    "data-test-subj": PropTypes.string,
    css: PropTypes.any,
    // Boolean values are not meaningful to this EuiSearchBox, but are allowed so that other
    // components can use e.g. a true value to mean "auto-derive a schema". See EuiInMemoryTable.
    // Admittedly, this is a bit of a hack.
    schema: PropTypes.oneOfType([PropTypes.shape({
      strict: PropTypes.bool,
      fields: PropTypes.any,
      flags: PropTypes.arrayOf(PropTypes.string.isRequired)
    }).isRequired, PropTypes.bool.isRequired])
  }),
  /**
     An array of search filters. See #SearchFilterConfig.
     */
  filters: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    type: PropTypes.oneOf(["is"]).isRequired,
    field: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    negatedName: PropTypes.string,
    available: PropTypes.func
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["field_value_selection"]).isRequired,
    field: PropTypes.string,
    name: PropTypes.string.isRequired,
    /**
       * See #FieldValueOptionType
       */
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
      field: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
        type: PropTypes.oneOf(["date"]).isRequired,
        raw: PropTypes.any.isRequired,
        granularity: PropTypes.oneOfType([PropTypes.shape({
          es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
          js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
          isSame: PropTypes.func.isRequired,
          start: PropTypes.func.isRequired,
          startOfNext: PropTypes.func.isRequired,
          iso8601: PropTypes.func.isRequired
        }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
        text: PropTypes.string.isRequired,
        resolve: PropTypes.func.isRequired
      }).isRequired]).isRequired,
      name: PropTypes.string,
      view: PropTypes.node
    }).isRequired).isRequired, PropTypes.func.isRequired]).isRequired,
    filterWith: PropTypes.oneOfType([PropTypes.oneOf(["prefix", "includes"]), PropTypes.func.isRequired]),
    cache: PropTypes.number,
    multiSelect: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.oneOf(["and", "or"])]),
    loadingMessage: PropTypes.string,
    noOptionsMessage: PropTypes.string,
    searchThreshold: PropTypes.number,
    available: PropTypes.func,
    autoClose: PropTypes.bool,
    operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["field_value_toggle"]).isRequired,
    field: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
      type: PropTypes.oneOf(["date"]).isRequired,
      raw: PropTypes.any.isRequired,
      granularity: PropTypes.oneOfType([PropTypes.shape({
        es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
        js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
        isSame: PropTypes.func.isRequired,
        start: PropTypes.func.isRequired,
        startOfNext: PropTypes.func.isRequired,
        iso8601: PropTypes.func.isRequired
      }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
      text: PropTypes.string.isRequired,
      resolve: PropTypes.func.isRequired
    }).isRequired]).isRequired,
    name: PropTypes.string.isRequired,
    negatedName: PropTypes.string,
    available: PropTypes.func,
    operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["field_value_toggle_group"]).isRequired,
    field: PropTypes.string.isRequired,
    /**
       * See #FieldValueToggleGroupFilterItemType
       */
    items: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired]).isRequired,
      name: PropTypes.string.isRequired,
      negatedName: PropTypes.string,
      operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
    }).isRequired).isRequired,
    available: PropTypes.func
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["custom_component"]).isRequired,
    component: PropTypes.elementType.isRequired,
    available: PropTypes.func
  }).isRequired]).isRequired),
  /**
     * Tools which go to the left of the search bar.
     */
  toolsLeft: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.arrayOf(PropTypes.element.isRequired).isRequired]),
  /**
     * Tools which go to the right of the search bar.
     */
  toolsRight: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.arrayOf(PropTypes.element.isRequired).isRequired]),
  /**
     * Date formatter to use when parsing date values
     */
  dateFormat: PropTypes.any,
  /**
     * Hint to render below the search bar
     */
  hint: PropTypes.shape({
    content: PropTypes.node.isRequired,
    popoverProps: PropTypes.any
  }),
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  css: PropTypes.any
}).isRequired];
export var SearchFilterConfigProps = function SearchFilterConfigProps() {
  return ___EmotionJSX("div", null);
};
SearchFilterConfigProps.propTypes = [PropTypes.shape({
  type: PropTypes.oneOf(["is"]).isRequired,
  field: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  negatedName: PropTypes.string,
  available: PropTypes.func
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["field_value_selection"]).isRequired,
  field: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
      type: PropTypes.oneOf(["date"]).isRequired,
      raw: PropTypes.any.isRequired,
      granularity: PropTypes.oneOfType([PropTypes.shape({
        es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
        js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
        isSame: PropTypes.func.isRequired,
        start: PropTypes.func.isRequired,
        startOfNext: PropTypes.func.isRequired,
        iso8601: PropTypes.func.isRequired
      }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
      text: PropTypes.string.isRequired,
      resolve: PropTypes.func.isRequired
    }).isRequired]).isRequired,
    name: PropTypes.string,
    view: PropTypes.node
  }).isRequired).isRequired, PropTypes.func.isRequired]).isRequired,
  filterWith: PropTypes.oneOfType([PropTypes.oneOf(["prefix", "includes"]), PropTypes.func.isRequired]),
  cache: PropTypes.number,
  multiSelect: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.oneOf(["and", "or"])]),
  loadingMessage: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  searchThreshold: PropTypes.number,
  available: PropTypes.func,
  autoClose: PropTypes.bool,
  operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["field_value_toggle"]).isRequired,
  field: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["date"]).isRequired,
    raw: PropTypes.any.isRequired,
    granularity: PropTypes.oneOfType([PropTypes.shape({
      es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
      js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
      isSame: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      startOfNext: PropTypes.func.isRequired,
      iso8601: PropTypes.func.isRequired
    }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
    text: PropTypes.string.isRequired,
    resolve: PropTypes.func.isRequired
  }).isRequired]).isRequired,
  name: PropTypes.string.isRequired,
  negatedName: PropTypes.string,
  available: PropTypes.func,
  operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["field_value_toggle_group"]).isRequired,
  field: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired]).isRequired,
    name: PropTypes.string.isRequired,
    negatedName: PropTypes.string,
    operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
  }).isRequired).isRequired,
  available: PropTypes.func
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["custom_component"]).isRequired,
  component: PropTypes.elementType.isRequired,
  available: PropTypes.func
}).isRequired];
export var EuiTableRowCellMobileOptionsShape = () => <div />;
try {
  DefaultItemActionProps.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/tables/props/props.tsx',
    description: '',
    displayName: 'DefaultItemActionProps',
    methods: [],
    props: {
      type: {
        defaultValue: null,
        description: 'The type of action',
        name: 'type',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        }, {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemEmptyButtonAction'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"button" | "icon"',
          value: [{
            value: '"button"'
          }, {
            value: '"icon"'
          }]
        }
      },
      icon: {
        defaultValue: null,
        description: 'Associates an icon with the button',
        name: 'icon',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        }],
        required: false,
        type: {
          name: '"string" | "number" | "function" | "fullScreen" | "color" | "search" | "link" | "at" | "article" | "menu" | "filter" | "image" | "stop" | "error" | "pause" | "play" | "offline" | ... 472 more ... | IconFunction<...>'
        }
      },
      color: {
        defaultValue: null,
        description: 'Defines the color of the button',
        name: 'color',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        }, {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemEmptyButtonAction'
        }],
        required: false,
        type: {
          name: '"text" | "accent" | "primary" | "success" | "warning" | "danger" | EuiButtonIconColorFunction<T>'
        }
      },
      name: {
        defaultValue: null,
        description: 'The display name of the action (will render as visible text if rendered within a collapsed menu)',
        name: 'name',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: true,
        type: {
          name: 'ReactNode | ((item: T) => ReactNode)'
        }
      },
      description: {
        defaultValue: null,
        description: 'Describes the action (will render as tooltip content)',
        name: 'description',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: true,
        type: {
          name: 'string | ((item: T) => string)'
        }
      },
      onClick: {
        defaultValue: null,
        description: 'A handler function to execute the action',
        name: 'onClick',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: '(item: T) => void'
        }
      },
      href: {
        defaultValue: null,
        description: '',
        name: 'href',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: 'string | ((item: T) => string)'
        }
      },
      target: {
        defaultValue: null,
        description: '',
        name: 'target',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      available: {
        defaultValue: null,
        description: 'A callback function that determines whether the action is available',
        name: 'available',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: '(item: T) => boolean'
        }
      },
      enabled: {
        defaultValue: null,
        description: 'A callback function that determines whether the action is enabled',
        name: 'enabled',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: '(item: T) => boolean'
        }
      },
      isPrimary: {
        defaultValue: null,
        description: '',
        name: 'isPrimary',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: 'string | ((item: T) => string)'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType', 'CustomComponentFilterConfigType', 'EuiTableRowCellMobileOptionsShape', 'EuiTableRowCellSharedPropsShape']
  };
} catch (e) {}
try {
  SearchProps.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/tables/props/props.tsx',
    description: '',
    displayName: 'SearchProps',
    methods: [],
    props: {
      onChange: {
        defaultValue: null,
        description: '',
        name: 'onChange',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: '(args: EuiSearchBarOnChangeArgs) => boolean | void'
        }
      },
      defaultQuery: {
        defaultValue: null,
        description: 'The initial query the bar will hold when first mounted',
        name: 'defaultQuery',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'QueryType'
        }
      },
      query: {
        defaultValue: null,
        description: 'If you wish to use the search bar as a controlled component, continuously pass the query via this prop.',
        name: 'query',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'QueryType'
        }
      },
      box: {
        defaultValue: null,
        description: 'Configures the search box. Set `placeholder` to change the placeholder text in the box and `incremental` to support incremental (as you type) search.',
        name: 'box',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'EuiFieldSearchProps & { schema?: boolean | SchemaType; }'
        }
      },
      filters: {
        defaultValue: null,
        description: 'An array of search filters. See #SearchFilterConfig.',
        name: 'filters',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'SearchFilterConfig[]'
        }
      },
      toolsLeft: {
        defaultValue: null,
        description: 'Tools which go to the left of the search bar.',
        name: 'toolsLeft',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'Tools'
        }
      },
      toolsRight: {
        defaultValue: null,
        description: 'Tools which go to the right of the search bar.',
        name: 'toolsRight',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'Tools'
        }
      },
      dateFormat: {
        defaultValue: null,
        description: 'Date formatter to use when parsing date values',
        name: 'dateFormat',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'object'
        }
      },
      hint: {
        defaultValue: null,
        description: 'Hint to render below the search bar',
        name: 'hint',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: '{ content: React.ReactNode; popoverProps?: Partial<Pick<EuiInputPopoverProps, "data-test-subj" | "fullWidth" | "isOpen" | "closePopover" | "panelClassName" | "panelPaddingSize" | ... 5 more ... | "disableFocusTrap">>; }'
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: '',
        name: 'aria-label',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      css: {
        defaultValue: null,
        description: '',
        name: 'css',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'Interpolation<Theme>'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType', 'CustomComponentFilterConfigType', 'EuiTableRowCellMobileOptionsShape', 'EuiTableRowCellSharedPropsShape']
  };
} catch (e) {}
try {
  SearchFilterConfigProps.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/tables/props/props.tsx',
    description: '',
    displayName: 'SearchFilterConfigProps',
    methods: [],
    props: {
      type: {
        defaultValue: null,
        description: '',
        name: 'type',
        parent: {
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/custom_component_filter.tsx',
          name: 'CustomComponentFilterConfigType'
        }],
        required: true,
        type: {
          name: 'enum',
          raw: '"is" | "field_value_selection" | "field_value_toggle" | "field_value_toggle_group" | "custom_component"',
          value: [{
            value: '"is"'
          }, {
            value: '"field_value_selection"'
          }, {
            value: '"field_value_toggle"'
          }, {
            value: '"field_value_toggle_group"'
          }, {
            value: '"custom_component"'
          }]
        }
      },
      field: {
        defaultValue: null,
        description: '',
        name: 'field',
        parent: {
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      name: {
        defaultValue: null,
        description: '',
        name: 'name',
        parent: {
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      negatedName: {
        defaultValue: null,
        description: '',
        name: 'negatedName',
        parent: {
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      available: {
        defaultValue: null,
        description: '',
        name: 'available',
        parent: {
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/custom_component_filter.tsx',
          name: 'CustomComponentFilterConfigType'
        }],
        required: false,
        type: {
          name: '(() => boolean) | (() => boolean) | (() => boolean) | (() => boolean) | (() => boolean)'
        }
      },
      options: {
        defaultValue: null,
        description: 'See #FieldValueOptionType',
        name: 'options',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: true,
        type: {
          name: 'FieldValueOptionType[] | OptionsLoader'
        }
      },
      filterWith: {
        defaultValue: null,
        description: '',
        name: 'filterWith',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: '"prefix" | "includes" | OptionsFilter'
        }
      },
      cache: {
        defaultValue: null,
        description: '',
        name: 'cache',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'number'
        }
      },
      multiSelect: {
        defaultValue: null,
        description: '',
        name: 'multiSelect',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'MultiSelect'
        }
      },
      loadingMessage: {
        defaultValue: null,
        description: '',
        name: 'loadingMessage',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      noOptionsMessage: {
        defaultValue: null,
        description: '',
        name: 'noOptionsMessage',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      searchThreshold: {
        defaultValue: null,
        description: '',
        name: 'searchThreshold',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'number'
        }
      },
      autoClose: {
        defaultValue: null,
        description: '',
        name: 'autoClose',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      operator: {
        defaultValue: null,
        description: '',
        name: 'operator',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }, {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: 'OperatorType',
          value: [{
            value: '"eq"'
          }, {
            value: '"exact"'
          }, {
            value: '"gt"'
          }, {
            value: '"gte"'
          }, {
            value: '"lt"'
          }, {
            value: '"lte"'
          }]
        }
      },
      value: {
        defaultValue: null,
        description: '',
        name: 'value',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }],
        required: true,
        type: {
          name: 'Value'
        }
      },
      items: {
        defaultValue: null,
        description: 'See #FieldValueToggleGroupFilterItemType',
        name: 'items',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        }],
        required: true,
        type: {
          name: 'FieldValueToggleGroupFilterItemType[]'
        }
      },
      component: {
        defaultValue: null,
        description: '',
        name: 'component',
        parent: {
          fileName: 'app/src/components/search_bar/filters/custom_component_filter.tsx',
          name: 'CustomComponentFilterConfigType'
        },
        declarations: [{
          fileName: 'app/src/components/search_bar/filters/custom_component_filter.tsx',
          name: 'CustomComponentFilterConfigType'
        }],
        required: true,
        type: {
          name: 'React.ComponentType<T>'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType', 'CustomComponentFilterConfigType', 'EuiTableRowCellMobileOptionsShape', 'EuiTableRowCellSharedPropsShape']
  };
} catch (e) {}
try {
  EuiTableRowCellMobileOptionsShape.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/tables/props/props.tsx',
    description: '',
    displayName: 'EuiTableRowCellMobileOptionsShape',
    methods: [],
    props: {
      show: {
        defaultValue: null,
        description: 'If false, will not render the cell at all for mobile',
        name: 'show',
        parent: {
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      only: {
        defaultValue: null,
        description: 'Only show for mobile? If true, will not render the column at all for desktop',
        name: 'only',
        parent: {
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      render: {
        defaultValue: null,
        description: 'Custom render/children if different from desktop',
        name: 'render',
        parent: {
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      header: {
        defaultValue: null,
        description: "The column's header for use in mobile view (automatically passed down\n" + 'when using `EuiBasicTable`).\n' + 'Or pass `false` to not show a header at all.',
        name: 'header',
        parent: {
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      enlarge: {
        defaultValue: null,
        description: 'Increase text size compared to rest of cells',
        name: 'enlarge',
        parent: {
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      width: {
        defaultValue: null,
        description: 'Applies the value to the width of the cell in mobile view (typically 50%)',
        name: 'width',
        parent: {
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'Width<string | number>'
        }
      },
      align: {
        defaultValue: null,
        description: 'Horizontal alignment of the text in the cell',
        name: 'align',
        parent: {
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        },
        declarations: [{
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: 'HorizontalAlignment',
          value: [{
            value: '"center"'
          }, {
            value: '"left"'
          }, {
            value: '"right"'
          }]
        }
      },
      showOnHover: {
        defaultValue: null,
        description: '_Should only be used for action cells_',
        name: 'showOnHover',
        parent: {
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        },
        declarations: [{
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      textOnly: {
        defaultValue: null,
        description: 'Creates a text wrapper around cell content that helps word break or truncate\n' + 'long text correctly.',
        name: 'textOnly',
        parent: {
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        },
        declarations: [{
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      truncateText: {
        defaultValue: null,
        description: 'Indicates whether this column should truncate overflowing text content.\n' + '- Set to `true` to enable single-line truncation.\n' + '- To enable multi-line truncation, use a configuration object with `lines`\n' + 'set to a number of lines to truncate to.',
        name: 'truncateText',
        parent: {
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        },
        declarations: [{
          fileName: 'app/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        }],
        required: false,
        type: {
          name: 'boolean | { lines: number; }'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType', 'CustomComponentFilterConfigType', 'EuiTableRowCellMobileOptionsShape', 'EuiTableRowCellSharedPropsShape']
  };
} catch (e) {}